module.exports = __webpack_public_path__ + "img/equilibrium-960w.7afcfa13.jpg";